module.exports = __webpack_public_path__ + "img/cover-letter.6ad92787.svg";